const EPSILON = 0.005;

export function balanceNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? Math.round(number * 100) / 100 : 0;
}

export function hasBalanceValue(value) {
  return value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value));
}

export function balanceParts(balance, { baseline = null, projection = false } = {}) {
  const hasBaseline = hasBalanceValue(baseline?.saldo);
  const opening = balanceNumber(hasBaseline ? baseline.saldo : balance?.riportoPrecedente);
  const accrued = balanceNumber(balance?.maturate);
  const used = balanceNumber(balance?.godute);
  const planned = balanceNumber(balance?.programmate);
  const adjustments = balanceNumber(balance?.rettifiche);
  const available = balanceNumber(balance?.disponibile);
  const formulaResult = balanceNumber(opening + accrued + adjustments - used - planned);

  return {
    hasBaseline,
    opening,
    openingLabel: hasBaseline ? 'Saldo alla data di riferimento' : 'Riportato',
    accrued,
    accruedLabel: hasBaseline || projection ? 'Maturazione prevista' : 'Maturato',
    used,
    planned,
    adjustments,
    available,
    formulaResult,
    formulaMatches: Math.abs(formulaResult - available) < EPSILON,
  };
}

export function balanceProjectionLabel(year, projection) {
  return projection ? `Proiezione al 31/12/${year}` : 'Saldo disponibile alla data di riferimento';
}

export function balanceNarrative(parts, year, projection) {
  const openingText = `${parts.openingLabel.toLowerCase()} ${parts.opening}`;
  const sentences = [
    `Alla ${projection ? `proiezione al 31/12/${year}` : 'data di riferimento'} il saldo disponibile è di ${parts.available} giorni.`,
  ];

  if (parts.opening !== 0) sentences.push(`Si parte da ${openingText} giorni.`);
  if (parts.accrued !== 0) {
    sentences.push(`${parts.accruedLabel} ${parts.accrued} giorni.`);
  }
  if (parts.used !== 0) sentences.push(`Risultano ${parts.used} giorni già goduti.`);
  if (parts.planned !== 0) sentences.push(`Risultano ${parts.planned} giorni già programmati.`);
  if (parts.adjustments !== 0) {
    const sign = parts.adjustments < 0 ? 'negativa' : 'positiva';
    sentences.push(`È presente una rettifica ${sign} di ${Math.abs(parts.adjustments)} giorni.`);
  }

  return sentences.join(' ');
}